import { create } from 'zustand';

interface NetworkState {
  online: boolean;
  /** Last time the API answered; null if unknown. */
  apiReachableAt: number | null;
  apiDown: boolean;
  setOnline: (online: boolean) => void;
  markApi: (ok: boolean) => void;
}

export const useNetwork = create<NetworkState>((set) => ({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  apiReachableAt: null,
  apiDown: false,
  setOnline: (online) => set({ online }),
  markApi: (ok) => set(ok ? { apiDown: false, apiReachableAt: Date.now() } : { apiDown: true }),
}));

export function watchNetwork() {
  const update = () => useNetwork.getState().setOnline(navigator.onLine);
  window.addEventListener('online', update);
  window.addEventListener('offline', update);
  return () => {
    window.removeEventListener('online', update);
    window.removeEventListener('offline', update);
  };
}
